<template>
  <section>
    <modal :title="title" :show="showModal" @close="closeModal()">
      <div class="content" slot="content">
        <validation-observer ref="form">
        <form>
          <div class="flex column margin-top-l">
            <div class="flex-1">
              <validation-provider
                name="nome"
                rules="required"
                v-slot="{ errors }"
              >
                <div
                  class="form-field item group-input "
                  :class="{ errors: errors[0] }"
                >
                  Custo do produto:
                  <money class="flex input" style="max-width: 250px" v-model="costHistory.cost" v-bind="money"></money>
                  <span class="erros-alert">{{ errors[0] }}</span>
                </div>
              </validation-provider>
            </div>
            <div class="flex-1">
              <validation-provider
                name="nome"
                rules="required"
                v-slot="{ errors }"
              >
                <div
                  class="form-field item group-input "
                  :class="{ errors: errors[0] }"
                >
                  <div class="flex column">
                    <div class="flex-1">
                      Data inicial:
                    </div>
                    <div class="flex-1">
                      <date-picker v-model="costHistory.start_date" valueType="format"></date-picker>
                    </div>
                    <span class="erros-alert">{{ errors[0] }}</span>

                  </div>
                </div>
              </validation-provider>
            </div>
            <div class="flex-1">
              <validation-provider
                name="nome"
                rules="required"
                v-slot="{ errors }"
              >
                <div
                  class="form-field item group-input "
                  :class="{ errors: errors[0] }"
                >
                  <div class="flex column">
                    <div class="flex-1">
                      Data Final:
                    </div>
                    <div class="flex-1">
                      <date-picker v-model="costHistory.end_date" valueType="format"></date-picker>
                    </div>
                    <span class="erros-alert">{{ errors[0] }}</span>

                  </div>
                </div>
              </validation-provider>
            </div>

          </div>
        </form>
      </validation-observer>
      </div>
      <div class="action" slot="action">
        <div class="flex center">
          <button @click="closeModal()" class="button secondary medium">
            Voltar
          </button>
          <button
            type="submit"
            @click="acceptModal()"
            class="button primary medium"
            :class="{ unusual: unusual == 'accept' }"
          >
            {{ isEdit ? "Editar" : "Criar" }}
          </button>
        </div>
      </div>
    </modal>
  </section>
</template>

<script>
import Modal from "@/components/modal/Modal";
import { Money } from 'v-money'

export default {
  name: "modal-lists",
  props: {
    titleName: {
      required: false,
      default: "Criar Lista",
    },
    show: {
      required: true,
      default: false,
    },
    unusual: {
      required: false,
      default: "false",
    },
    costHistory: {
      required: true,
      default: Object,
    },
  },
  components: {
    Modal,
    Money
  },
  data() {
    return {
      showDeleteModal: false,
      selectModalDelete: null,
      showModal: false,
      seenGuide: {},
      title: "Criar Custo",
    };
  },
  watch: {
    show(value) {
      this.showModal = value;
    },
  },
  updated() {
    if (this.isEdit) {
      this.title = 'Editar Custo'
    }
  },
  mounted() {
    if (this.isEdit) {
      this.title = 'Editar Custo'
    }
  },
  computed: {
    isEdit() {
      return this.costHistory && this.costHistory.id;
    },
  },
  methods: {
    acceptModal() {
      this.showModal = false;
      this.$emit("accept", this.costHistory);
    },
    closeModal() {
      this.showModal = false;
      this.$emit("close", false);
    },
  },
};
</script>

<style lang="scss" scoped>
.action {
  margin-top: 30px;
  .button {
    margin-left: 10px !important;
  }
}

textarea {
  border-radius: 5px;
  border: 1px solid #3333;
  padding: 15px;
  max-width: 500px;
  min-width: 500px;
  min-height: 150px;
  max-height: 150px;
}

ul {
  list-style: none;
  max-height: 200px;
  overflow-y: scroll;
  li {
    padding: 4px 8px;
    border-bottom: 1px solid #ccc;
    .tag {
      background: #c2c2c2;
      padding: 4px 6px;
      border-radius: 5px;
      font-size: 11px;
      font-weight: 800;
      margin-left: 8px;
    }
    .button {
      margin-left: 4px;
      padding: 4px 6px;
    }
  }
}
</style>
